import React, { useState, useEffect } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {
  Button,
  TextField,
  Grid,
  Typography,
  Avatar,
  Paper,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  Radio,
  RadioGroup,
  MenuItem,
} from "@material-ui/core";

import api from "../../../../Axios/api";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import useStyles from "./styles";

import { useUserContext } from "../../../../context/UserContext";

export default function AddStore() {
  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const classes = useStyles();

  // context
  const { store } = useUserContext();
  const token = store.data.token;
  const [storeDetails, setStoreDetails] = useState({
    name: "",
    category: "",
    biography: "A place to have trust.",
    warehouseAddress: "Street No. 231, 2484  Fairfield Road",
    buissnessAddress: "Street No. 231, 2484  Fairfield Road",
    city: "Islamabad",
    country: "Pakistan",
    type: "individual",
    sellerName: "",
  });
  const handleStoreDetails = (input) => (e) => {
    setStoreDetails({ ...storeDetails, [input]: e.target.value });
  };
  const [sellerList, setSellerList] = useState([]);
  const [IFerrors, setIFerrors] = useState({
    nameError: "",
    categoryError: "",
    warehouseAddressError: "",
    buissnessAddressError: "",
    cityError: "",
    countryError: "",
    sellerNameError: "",
  });

  const InputValidation = () => {
    const errors = {};
    var hasError = false;

    // name
    var nameFormat = /^[0-9A-Za-z\s_+()'#@&-]+$/;
    if (storeDetails.name.match(nameFormat)) {
      errors.nameError = "";
    } else {
      hasError = true;
      errors.nameError =
        "Invalid Input. Name cannot contains several Special Characters!";
    }

    // seller List
    if (storeDetails.sellerName.length === 0) {
      hasError = true;
      errors.sellerNameError = "Please Choose Seller to add Store!";
    } else {
      errors.sellerNameError = "";
    }

    // city
    var cityFormat = /^([^0-9]*)$/;
    if (storeDetails.city.match(cityFormat)) {
      errors.cityError = "";
    } else {
      hasError = true;
      errors.cityError = "City cannot contains Numbers or Special Characters!";
    }

    // country
    var countryFormat = /^([^0-9]*)$/;
    if (storeDetails.country.match(countryFormat)) {
      errors.countryError = "";
    } else {
      hasError = true;
      errors.countryError =
        "Country cannot contains Numbers or Special Characters!";
    }

    // address
    var addressFormat = /^[a-zA-Z0-9-@#{1},\s]*$/;
    if (
      storeDetails.warehouseAddress.match(addressFormat) &&
      storeDetails.warehouseAddress.length > 10
    ) {
      errors.warehouseAddressError = "";
    } else {
      hasError = true;
      errors.warehouseAddressError =
        "Entered Address is invalid. Special Characters not allowed i.e. /!$%^&*()";
    }

    setIFerrors({ ...IFerrors, ...errors });
    return hasError;
  };

  const getAllSellers = async () => {
    api
      .get("/superAdmin/sellers/stores/unregistered", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const vList = res.data.data.sellers;
        console.log("sellers are ", res.data.data.sellers);
        setSellerList(vList);
      })
      .catch((error) => console.log("Error: " + error));
  };

  const addStoreHandler = (e) => {
    e.preventDefault();
    var hasError = InputValidation();

    if (hasError === false) {
      api
        .post(
          `/superAdmin/store/register/seller/${storeDetails.sellerName}`,
          {
            ...storeDetails,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "Store has been added successfully!",
            open: true,
          });
        })
        .catch((error) =>
          setSnackBar({
            ...snackBarstate,
            message: "ERROR: " + JSON.stringify(error.response.data.error),
            type: "error",
            open: true,
          })
        );
    }
  };

  useEffect(() => {
    getAllSellers();
    // eslint-disable-next-line
  }, []);
  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={12} md={12} component={Paper}>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LibraryAddIcon />
          </Avatar>
          <Typography variant="h5">Register Store</Typography>
          <form className={classes.form} noValidate style={{ padding: 20 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Select
                  variant="outlined"
                  margin="dense"
                  required
                  fullWidth
                  label="Seller Name"
                  style={{ marginTop: 8 }}
                  defaultValue={"DEFAULT"}
                  onChange={handleStoreDetails("sellerName")}
                  error={IFerrors.sellerNameError.length > 0 ? true : false}
                >
                  <MenuItem value="DEFAULT" disabled>
                    Choose a Seller
                  </MenuItem>
                  {sellerList.map((el, index) => (
                    <MenuItem value={el._id} key={index}>
                      {el.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  variant="outlined"
                  label="Store Name"
                  fullWidth
                  value={storeDetails.name}
                  onChange={handleStoreDetails("name")}
                  helperText={IFerrors.nameError}
                  error={IFerrors.nameError.length > 0 ? true : false}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <FormControl fullWidth>
                  <InputLabel>Category</InputLabel>
                  <Select
                    variant="outlined"
                    native
                    defaultValue={storeDetails.category}
                    onChange={handleStoreDetails("category")}
                    error={IFerrors.categoryError.length > 0 ? true : false}
                  >
                    <option value="Electronic">Electronics</option>
                    <option value="Health">Health and Beauty</option>
                    <option value="Groceries">Groceries & Pets</option>
                    <option value="Lifestyle">Home & Lifestyle</option>
                    <option value="fashion">Fashion & Clothing</option>
                    <option value="sports">Sports</option>
                    <option value="automotive">Automotive and Bikes</option>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  name="storeBio"
                  label="Biography"
                  fullWidth
                  defaultValue={storeDetails.biography}
                  onChange={handleStoreDetails("biography")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  variant="outlined"
                  required
                  name="warehouseAddress"
                  label="Warehouse Address"
                  fullWidth
                  defaultValue={storeDetails.warehouseAddress}
                  onChange={handleStoreDetails("warehouseAddress")}
                  helperText={IFerrors.warehouseAddressError}
                  error={
                    IFerrors.warehouseAddressError.length > 0 ? true : false
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  variant="outlined"
                  required
                  name="warehouseAddress"
                  label="Warehouse Address"
                  fullWidth
                  defaultValue={storeDetails.warehouseAddress}
                  onChange={handleStoreDetails("warehouseAddress")}
                  helperText={IFerrors.warehouseAddressError}
                  error={
                    IFerrors.warehouseAddressError.length > 0 ? true : false
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  variant="outlined"
                  required
                  name="city"
                  label="City"
                  fullWidth
                  defaultValue={storeDetails.city}
                  onChange={handleStoreDetails("city")}
                  helperText={IFerrors.cityError}
                  error={IFerrors.cityError.length > 0 ? true : false}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  name="country"
                  label="Country"
                  fullWidth
                  defaultValue={storeDetails.country}
                  onChange={handleStoreDetails("country")}
                  helperText={IFerrors.countryError}
                  error={IFerrors.countryError.length > 0 ? true : false}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <RadioGroup
                  row
                  value={storeDetails.type}
                  onChange={handleStoreDetails("type")}
                >
                  <FormControlLabel
                    value="individual"
                    control={<Radio color="secondary" />}
                    label="I'm an Individual"
                  />
                  <FormControlLabel
                    value="shop"
                    control={<Radio color="secondary" />}
                    label="I'm a Shopkepper"
                  />
                  <FormControlLabel
                    value="brand"
                    control={<Radio color="secondary" />}
                    label="We're a Brand"
                  />
                </RadioGroup>
              </Grid>
              <Grid item xs={12}></Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12} align="center">
                <Button
                  size="large"
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={addStoreHandler}
                >
                  Add Store
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Grid>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
    </Grid>
  );
}
